<template>
  <div class="col-12 cryptoNewsLatest">
    <div class="container mb-5">
      <div class="row CryptoMarketScreener">
        <div class="col-12 text-center mb-4">
          <p>
            Find the latest Bitcoin and cryptocurrency news for Businesses and
            Individuals
          </p>
        </div>
        <div class="col-12 text-center" v-if="cryptoNewsList.length > 0">
          <VueSlickCarousel v-bind="settings" :arrows="true">
            <div
              class="newUpdate position-relative"
              v-for="item in cryptoNewsList"
            >
              <img class="d-block w-100 mb-4" :src="item.image" alt="Image" />
              <h6 class="semibold" v-html="item.title"></h6>
            </div>
            <!-- <div class="newUpdate position-relative">
	                        <img class="d-block w-100 mb-4" src="../../../../static/website/images/news-3.png" alt="Image" />
	                        <h6 class="semibold">
	                            Twitter Launches Verification Mechanism for NFT Avatars
	                        </h6>
	                    </div>
	                    <div class="newUpdate position-relative">
	                        <img class="d-block w-100 mb-4" src="../../../../static/website/images/news-4.png" alt="Image" />
	                        <h6 class="semibold">
	                            Google Forms New Team to Shape Blockchain Venture
	                        </h6>
	                    </div>
	                    <div class="newUpdate position-relative">
	                        <img class="d-block w-100 mb-4" src="../../../../static/website/images/news-5.png" alt="Image" />
	                        <h6 class="semibold">
	                            NYC Mayor to Receive 1st Paycheck in Crypto-converted
	                        </h6>
	                    </div>
	                    <div class="newUpdate position-relative">
	                        <img class="d-block w-100 mb-4" src="../../../../static/website/images/news-5.png" alt="Image" />
	                        <h6 class="semibold">
	                            NYC Mayor to Receive 1st Paycheck in Crypto-converted
	                        </h6>
	                    </div> -->
          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <div class="row bottomNewsArticle">
      <div class="col-12 col-md-12">
        <div class="row">
          <div
            class="col-12 mb-md-4 d-flex align-items-center justify-content-between"
          >
            <h5 class="flex-shrink-0 medium">All News Articles</h5>
            <!-- <ul class="filterTab d-flex align-items-center">
	                        <li>
	                            <a class="l-1 filter" href="javascript:void(0)"><feather class="rotate" type="sliders"></feather> </a>
	                        </li>
	                        <li class="hideMobile">
	                            <div class="position-relative searchIcon">
	                                <input type="text" placeholder="Search Articles" class="form-control small" name="" />
	                                <a href="javascript:void(0)" class="l-1 s-icon position-absolute"><feather size="20px" type="search"></feather></a>
	                            </div>
	                        </li>
	                    </ul> -->
          </div>
          <div class="col-12 col-md-8">
            <div
              class="main-title d-flex align-items-center justify-content-between border-bottom mb-4"
            >
              <h6>Latest News</h6>
              <a
                class="f-11 themecolor d-flex align-items-center"
                :href="$env_var.newsLink"
                target="_blank"
                >View All <feather class="me-1" type="arrow-right"></feather
              ></a>
            </div>
            <div class="row">
              <div
                class="col-12 col-md-6 ps-0 mb-4"
                v-for="(item, index) in newsList"
                v-if="index < 4"
              >
                <div class="card-body p-0">
                  <img :src="item.image" alt="Icon" />
                  <p class="f-14 medium darktext my-2" v-html="item.title"></p>
                  <div class="walkers">
                    <p class="f-12">
                      <span class="secondary semibold">{{
                        item.author.Name
                      }}</span>
                      <!-- JAN 23, 2022 | 2 MIN READ -->{{
                        item.created | moment("MMM DD, YYYY")
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="col-12 col-md-6 ps-0 mb-4">
	                            <div class="card-body p-0">
	                                <img src="../../../../static/website/images/mtx-1.png" alt="Icon" />
	                                <p class="f-14 medium darktext my-2">
	                                    US Law Makers Engage with Crypto Industry Leaders to Discuss Regulation
	                                </p>
	                                <div class="walkers">
	                                    <p class="f-12">
	                                        <span class="secondary semibold">Sheilla Spade</span>
	                                        JAN 23, 2022 | 2 MIN READ
	                                    </p>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="col-12 col-md-6 pe-0 mb-4">
	                            <div class="card-body p-0">
	                                <img src="../../../../static/website/images/mtx-3.png" alt="Icon" />
	                                <p class="f-14 medium darktext my-2">
	                                    Crypto Prices Drop after US Stockmarket Plunges, NFT Volumes Barely Seem Affected
	                                </p>
	                                <div class="walkers">
	                                    <p class="f-12">
	                                        <span class="secondary semibold">Ray Walkers</span>
	                                        JAN 22, 2022 | 1 MIN READ
	                                    </p>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="col-12 col-md-6 ps-0">
	                            <div class="card-body p-0">
	                                <img src="../../../../static/website/images/mtx-2.png" alt="Icon" />
	                                <p class="f-14 medium darktext my-2">
	                                    Mercado Libre Injects Liquidity into Crypto Firms Paxos & 2TM
	                                </p>
	                                <div class="walkers">
	                                    <p class="f-12">
	                                        <span class="secondary semibold">William Ben</span>
	                                        JAN 22, 2022 | 1 MIN READ
	                                    </p>
	                                </div>
	                            </div>
	                        </div>
	                        <div class="col-12 col-md-6 pe-0">
	                            <div class="card-body p-0">
	                                <img src="../../../../static/website/images/mtx-4.png" alt="Icon" />
	                                <p class="f-14 medium darktext my-2">
	                                    Gap Launches Gamified Collectible NFT Experience to Activate Community, Creativity and Self-Expression
	                                </p>
	                                <div class="walkers">
	                                    <p class="f-12">
	                                        <span class="secondary semibold">Aubrey Hedden</span>
	                                        JAN 22, 2022 | 1 MIN READ
	                                    </p>
	                                </div>
	                            </div>
	                        </div> -->
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div
              class="main-title d-flex align-items-center justify-content-between border-bottom mb-4"
            >
              <h6>Trending in Crypto</h6>
              <a
                class="f-11 themecolor d-flex align-items-center"
                :href="$env_var.newsLink"
                target="_blank"
                >View All <feather class="me-1" type="arrow-right"></feather
              ></a>
            </div>
            <ul class="criptoList">
              <li v-for="(item, index) in cryptoNewsList" v-if="index < 3">
                <a href="javascript:void(0)" v-html="item.title"></a>
              </li>
              <!-- <li>
	                            <a href="javascript:void(0)">Bitcoin ‘enters value zone’ as BTC price floor metric goes green again</a>
	                        </li>
	                        <li>
	                            <a href="javascript:void(0)">No regrets for NYC mayor receiving his first Bitcoin paycheck during dip</a>
	                        </li>
	                        <li>
	                            <a href="javascript:void(0)">Bank of Korea completes first phase of digital currency pilot</a>
	                        </li> -->
            </ul>
            <div
              class="main-title d-flex align-items-center justify-content-between border-bottom"
            >
              <h6>Top Headline</h6>
              <a
                class="f-11 themecolor d-flex align-items-center"
                :href="$env_var.newsLink"
                target="_blank"
                >View All <feather class="me-1" type="arrow-right"></feather
              ></a>
            </div>
            <ul class="criptoList">
              <li v-for="(item, index) in newsList" v-if="index < 3">
                <a href="javascript:void(0)" v-html="item.title"></a>
              </li>
              <!-- <li>
	                            <a href="javascript:void(0)">Bitcoin Dips to Lowest Level in Five Months below $39K</a>
	                        </li>
	                        <li>
	                            <a href="javascript:void(0)">Central Bank of Russia Intends to Ban Crypto Mining and Activities</a>
	                        </li>
	                        <li>
	                            <a href="javascript:void(0)">Discovery Communications Releases Puppy Bowl NFTs to Benefit Ariana’s Animal Rescue Charity</a>
	                        </li> -->
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-md-5">
	            <div class="mb-md-4 d-flex align-items-center justify-content-between">
	                <h5 class="flex-shrink-0 medium">Crypto Economic Calendar</h5>
	                <ul class="filterTab d-flex align-items-center">
	                    <li>
	                        <a class="l-1 filter" href="javascript:void(0)"><feather class="rotate" type="sliders"></feather> </a>
	                    </li>
	                    <li class="hideMobile">
	                        <div class="position-relative searchIcon">
	                            <input type="text" placeholder="Search Articles" class="form-control small" name="" />
	                            <a href="javascript:void(0)" class="l-1 s-icon position-absolute"><feather size="20px" type="search"></feather></a>
	                        </div>
	                    </li>
	                </ul>
	            </div>
	            <div class="row economicCalendar">
	                <div class="col-12 col-md-6 mb-4">
	                    <div class="card-body text-center p-0">
	                        <img class="pt-3" src="../../../../static/website/images/reef.png" alt="Icon" />
	                        <h6 class="medium darktext mt-2 mb-0">
	                            Reef Finance (REEF)
	                        </h6>
	                        <p class="f-12">31 Jan 2022 (or earlier)</p>
	                        <div class="walkers px-3">
	                            <p class="f-12 mb-0">
	                                REEF Debit Card will be released in Mid-January 2022
	                            </p>
	                            <span class="f-12 d-flex align-items-center justify-content-between"><span>93%</span><span>7078 Votes</span></span>
	                            <div class="progress">
	                                <div class="progress-bar secondaryBG" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
	                            </div>
	                            <div class="thumbs d-flex align-items-center justify-content-center my-3">
	                                <a class="greenBG" href="javascript:void(0)"><feather type="thumbs-up"></feather></a>
	                                <a class="redBG" href="javascript:void(0)"><feather type="thumbs-down"></feather></a>
	                            </div>
	                        </div>
	                        <p class="f-14 btFooter">Added 23 Dec 2021</p>
	                    </div>
	                </div>
	                <div class="col-12 col-md-6 mb-4">
	                    <div class="card-body text-center p-0">
	                        <img class="pt-3" src="../../../../static/website/images/secret.png" alt="Icon" />
	                        <h6 class="medium darktext mt-2 mb-0">Secret (SCRT)</h6>
	                        <p class="f-12">31 Jan 2022 (or earlier)</p>
	                        <div class="walkers px-3">
	                            <p class="f-12 mb-0">
	                                Secret Terra Bridge brings interoperable privacy to digital tokens
	                            </p>
	                            <span class="f-12 d-flex align-items-center justify-content-between"><span>93%</span><span>7078 Votes</span></span>
	                            <div class="progress">
	                                <div class="progress-bar secondaryBG" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
	                            </div>
	                            <div class="thumbs d-flex align-items-center justify-content-center my-3">
	                                <a class="greenBG" href="javascript:void(0)"><feather type="thumbs-up"></feather></a>
	                                <a class="redBG" href="javascript:void(0)"><feather type="thumbs-down"></feather></a>
	                            </div>
	                        </div>
	                        <p class="f-14 btFooter">Added 23 Dec 2021</p>
	                    </div>
	                </div>
	                <div class="col-12 col-md-6">
	                    <div class="card-body text-center p-0">
	                        <img class="pt-3" src="../../../../static/website/images/reef.png" alt="Icon" />
	                        <h6 class="medium darktext mt-2 mb-0">
	                            Reef Finance (REEF)
	                        </h6>
	                        <p class="f-12">31 Jan 2022 (or earlier)</p>
	                        <div class="walkers px-3">
	                            <p class="f-12 mb-0">
	                                REEF Debit Card will be released in Mid-January 2022
	                            </p>
	                            <span class="f-12 d-flex align-items-center justify-content-between"><span>93%</span><span>7078 Votes</span></span>
	                            <div class="progress">
	                                <div class="progress-bar secondaryBG" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
	                            </div>
	                            <div class="thumbs d-flex align-items-center justify-content-center my-3">
	                                <a class="greenBG" href="javascript:void(0)"><feather type="thumbs-up"></feather></a>
	                                <a class="redBG" href="javascript:void(0)"><feather type="thumbs-down"></feather></a>
	                            </div>
	                        </div>
	                        <p class="f-14 btFooter">Added 23 Dec 2021</p>
	                    </div>
	                </div>
	                <div class="col-12 col-md-6">
	                    <div class="card-body text-center p-0">
	                        <img class="pt-3" src="../../../../static/website/images/reef.png" alt="Icon" />
	                        <h6 class="medium darktext mt-2 mb-0">
	                            Reef Finance (REEF)
	                        </h6>
	                        <p class="f-12">31 Jan 2022 (or earlier)</p>
	                        <div class="walkers px-3">
	                            <p class="f-12 mb-0">
	                                REEF Debit Card will be released in Mid-January 2022
	                            </p>
	                            <span class="f-12 d-flex align-items-center justify-content-between"><span>93%</span><span>7078 Votes</span></span>
	                            <div class="progress">
	                                <div class="progress-bar secondaryBG" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
	                            </div>
	                            <div class="thumbs d-flex align-items-center justify-content-center my-3">
	                                <a class="greenBG" href="javascript:void(0)"><feather type="thumbs-up"></feather></a>
	                                <a class="redBG" href="javascript:void(0)"><feather type="thumbs-down"></feather></a>
	                            </div>
	                        </div>
	                        <p class="f-14 btFooter">Added 23 Dec 2021</p>
	                    </div>
	                </div>
	            </div>
	        </div> -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import VueSlickCarousel from "vue-slick-carousel";
export default {
  name: "markets",
  data() {
    return {
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  components: { VueSlickCarousel },
  methods: {},
  computed: {},
  created() {
    this._runGetNewsList({
      globalParams: { page: 1, perPage: 10, tags: "CryptoCurrencies" },
      localParams: { parameter: this },
    });
    this._runGetNewsList({
      globalParams: {},
      localParams: { parameter: this },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/markets/news.vue